import * as actions from './actions'
import reducer from './reducer'
import SignIn from './components/SignIn'
import SignUp from './components/SignUp'
import * as TypeAction from './actionTypes'


const config = {
    subConfig: [
        {
            route: {
                path: '/Login',
                exact: true,
                component: SignIn,
            }
        },
        {
            route: {
                path: '/SignUp',
                exact: true,
                component: SignUp
            }
        }],
    


}
export default config

export { actions, reducer, SignIn, SignUp, TypeAction }




// WEBPACK FOOTER //
// ./src/routes/public/Login/index.js